import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isMobile: false,
  isTablet: false,
  isIOS: false,
  loader: {
    isLoading: false,
    loadingText: '',
  },
  notification: {
    isShown: false,
    isError: false,
    message: '',
  },
  isOldContractAdmin: false,
  isNewContractAdmin: false,
  isReferralManager: false,
  vestingStartTime: null,
  unlockTime: null,
  lockupPeriod: null,
};

export const mainSlice = createSlice({
  name: 'main',
  initialState,
  reducers: {
    setMobile: (state, action) => {
      state.isMobile = action.payload;
    },
    setTablet: (state, action) => {
      state.isTablet = action.payload;
    },
    setIsIOS: (state, action) => {
      state.isIOS = action.payload;
    },
    setLoader: (state, action) => {
      state.loader.isLoading = action.payload.isLoading ?? state.loader.isLoading;
      state.loader.loadingText = action.payload.loadingText || '';
    },
    setNotification: (state, action) => {
      state.notification.message = action.payload.message;
      state.notification.isShown = true;
      state.notification.isError = action.payload.isError || false;
    },
    resetNotification: state => {
      state.notification = initialState.notification;
    },
    setIsOldContractAdmin: (state, action) => {
      state.isOldContractAdmin = action.payload;
    },
    setIsNewContractAdmin: (state, action) => {
      state.isNewContractAdmin = action.payload;
    },
    setIsReferralManager: (state, action) => {
      state.isReferralManager = action.payload;
    },
    setVestingStartTime: (state, action) => {
      state.vestingStartTime = action.payload;
    },
    setUnlockTime: (state, action) => {
      state.unlockTime = action.payload;
    },
    setLockupPeriod: (state, action) => {
      state.lockupPeriod = action.payload;
    },
  },
});

export const {
  setMobile,
  setIsIOS,
  setLoader,
  setTablet,
  setNotification,
  resetNotification,
  setIsOldContractAdmin,
  setIsNewContractAdmin,
  setIsReferralManager,
  setVestingStartTime,
  setUnlockTime,
  setLockupPeriod,
} = mainSlice.actions;

export default mainSlice.reducer;
